import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, AlertTriangle, Truck, Users, Settings, BookOpen, LogOut, Radio, Shield, Webhook } from 'lucide-react';

export default function Sidebar() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <aside className="sidebar">
      <div style={{ padding:'16px 16px 12px', borderBottom:'1px solid var(--border)' }}>
        <img src="/logo_cdm.svg" alt="Centro de Monitoreo"
          style={{ width:'100%', maxWidth:200, height:'auto', display:'block' }}
          onError={e => { e.target.style.display='none'; }}
        />
        <div style={{ fontSize:10, color:'var(--success)', fontFamily:'var(--font-mono)', letterSpacing:2, marginTop:6, display:'flex', alignItems:'center', gap:4 }}>
          <span style={{ width:6, height:6, borderRadius:'50%', background:'var(--success)', display:'inline-block' }}/>
          SISTEMA ACTIVO
        </div>
      </div>

      <div style={{ flex:1, overflowY:'auto' }}>
        <div className="nav-section">
          <div className="nav-label">Principal</div>
          <NavLink to="/dashboard" className={({ isActive }) => `nav-item${isActive?' active':''}`}><LayoutDashboard /> Dashboard</NavLink>
          <NavLink to="/eventos" className={({ isActive }) => `nav-item${isActive?' active':''}`}><AlertTriangle /> Eventos</NavLink>
          <NavLink to="/consultas" className={({ isActive }) => `nav-item${isActive?' active':''}`}><BookOpen /> Consultas</NavLink>
        </div>
        <div className="nav-section">
          <div className="nav-label">Catálogos</div>
          <NavLink to="/vehiculos" className={({ isActive }) => `nav-item${isActive?' active':''}`}><Truck /> Vehículos</NavLink>
          <NavLink to="/clientes" className={({ isActive }) => `nav-item${isActive?' active':''}`}><Users /> Clientes</NavLink>
          <NavLink to="/catalogos" className={({ isActive }) => `nav-item${isActive?' active':''}`}><Radio /> Catálogos</NavLink>
        </div>
        {isAdmin && (
          <div className="nav-section">
            <div className="nav-label">Administración</div>
            <NavLink to="/webhook-proveedores" className={({ isActive }) => `nav-item${isActive?' active':''}`}><Webhook /> Proveedores GPS</NavLink>
            <NavLink to="/usuarios" className={({ isActive }) => `nav-item${isActive?' active':''}`}><Shield /> Usuarios</NavLink>
            <NavLink to="/configuracion" className={({ isActive }) => `nav-item${isActive?' active':''}`}><Settings /> Configuración</NavLink>
          </div>
        )}
      </div>

      <div style={{ padding:'12px 0', borderTop:'1px solid var(--border)' }}>
        <div style={{ padding:'8px 20px', marginBottom:4 }}>
          <div style={{ fontSize:13, fontWeight:500, color:'var(--text-primary)' }}>{user?.nombre} {user?.apellido}</div>
          <div style={{ fontSize:10, color:'var(--text-muted)', fontFamily:'var(--font-mono)', textTransform:'uppercase', letterSpacing:1 }}>{user?.rol}</div>
        </div>
        <button className="nav-item" onClick={handleLogout} style={{ width:'100%', background:'none', border:'none', color:'var(--danger)', cursor:'pointer' }}>
          <LogOut size={16}/> Cerrar Sesión
        </button>
      </div>
    </aside>
  );
}
